/**
 * Le rotte stagione del BFF Limulo, per la scheda Leghe della Hub (`LeghePanel`).
 *
 * Stanno in un file loro, iniettate in `limuloApi`, e non dentro `limuloApi.ts`: quel file e' uno
 * dei piu' toccati del repo, e tre query di sola lettura dietro un flag non devono contendergli
 * le righe. Base query, token, `refetchOnFocus` e riscrittura del 401 sono quelli di `limuloApi`:
 * questo e' lo stesso client, non un secondo.
 * 🔴 E la stessa busta: `{ ok, organizationId, data, meta }`. Ogni `transformResponse` qui la srotola
 * (`paginaOf`/`posizioneOf` in `lib/limulo/leghe.ts`) — la prima stesura non lo faceva, e le tre
 * query rendevano `null` con qualunque 200 (revisione di #458; garanzia in
 * `tests/leghe-client-vero.test.tsx`).
 */
import { limuloApi } from '@/services/limuloApi';
import {
  LEGHE_ROUTES,
  LEGHE_SEASONS_LIMIT,
  LEGHE_TOP_LIMIT,
  paginaOf,
  posizioneOf,
  rigaOf,
  stagioneOf,
  type LegaPagina,
  type LegaPosizione,
  type LegaRiga,
  type LegaStagione,
} from '@/lib/limulo/leghe';

const legheApi = limuloApi.injectEndpoints({
  endpoints: (builder) => ({
    /** `GET /v1/seasons` — tutte, filtrate per gioco e stato dal chiamante (`legheInCorso`). */
    getLimuloSeasons: builder.query<LegaPagina<LegaStagione> | null, void>({
      query: () => ({ url: LEGHE_ROUTES.seasons, params: { limit: LEGHE_SEASONS_LIMIT } }),
      transformResponse: (response: unknown) => paginaOf(response, stagioneOf),
    }),
    /** `GET /v1/seasons/:seasonId/leaderboard` — le prime righe; una lega non partita risponde vuota. */
    getLimuloSeasonLeaderboard: builder.query<LegaPagina<LegaRiga> | null, string>({
      query: (seasonId) => ({ url: LEGHE_ROUTES.leaderboard(seasonId), params: { limit: LEGHE_TOP_LIMIT } }),
      transformResponse: (response: unknown) => paginaOf(response, rigaOf),
    }),
    /**
     * `GET /v1/leaderboard/me?seasonId=` — la MIA riga in QUELLA lega. ⛔ Senza `seasonId` qLeagues
     * risponde `null` e app-qlash-services l'ultima riga di QUALUNQUE stagione: il parametro non e'
     * facoltativo per questa scheda.
     */
    getLimuloMyLeaguePosition: builder.query<LegaPosizione | null, string>({
      query: (seasonId) => ({ url: LEGHE_ROUTES.me, params: { seasonId } }),
      transformResponse: (response: unknown) => posizioneOf(response),
    }),
  }),
});

export const {
  useGetLimuloSeasonsQuery,
  useGetLimuloSeasonLeaderboardQuery,
  useGetLimuloMyLeaguePositionQuery,
} = legheApi;
